import { AfterViewInit, Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
    selector: '[ndtLandscapeView]',
    standalone: false
})
export class ReportOutputContainerLandscapeDirective implements AfterViewInit {
   @HostBinding('class')
   elementClass = 'landscape';

   constructor(private elementRef: ElementRef) {}

   ngAfterViewInit(): void {
      const reportContainer = this.elementRef.nativeElement;
      const style: HTMLStyleElement = document.createElement('style');
      const css = '@page { size: a4 landscape; }';

      if (reportContainer) {
         style.appendChild(document.createTextNode(css));
         reportContainer.appendChild(style);
      }
   }
}
